export const colors = {
  PRIMARY_CTA: '#ffffff',
  GREY_LIGHT: '#dddddd',
  GREY_EXTRA_LIGHT: '#eeeeee'
}
